import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const MortgageFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4955903' height='625' />
}

export default React.memo(MortgageFormBlock)
